import 'Styles/userprofile.scss';

import React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';

import userprofileResultSelector from 'Selectors/userprofileResultSelector';

import UserIcon from 'Components/common/UserIconComponent';
import Date from 'Components/common/dateComponent';

import PostList from 'Components/posts/PostListComponent';
import AdComponent from 'Components/ads/AdComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import InfiniteScroll from 'Components/infiniteScroll/InfiniteScrollComponent';

import { fetchUserProfile } from 'Actions/UserprofileActions';
import { checkAdsPermissions, resetHiddenAdsPerUser, trackPageView, onPageView } from 'Actions/adsActions';

import { resetInfinite } from 'Actions/InfiniteScrollActions';
import { resetForum } from 'Actions/ForumviewActions';
import { resetThread } from 'Actions/ThreadviewActions';
import { resetUserProfile } from 'Actions/UserprofileActions';

import { pathToUserProfile } from 'Utils/nav/NavHelpers';

class UserProfileViewComponent extends React.Component {
	constructor(props) {
		super(props);

		this.redirect = false;
		this.state = {
			headerHeight: 0
		};
	}

	dispatchFetchUserProfile( props ) {
		let page = props.location.query.page || 1,
			userid = props.routeParams.userid;

		if( userid ) {
			this.props.dispatch( fetchUserProfile( {
				id: userid,
				page: parseInt( page )
			} ) );
		}
	}

	componentWillMount() {
		this.props.dispatch( checkAdsPermissions( 0 ) );
		this.props.dispatch( resetHiddenAdsPerUser() );
		this.props.dispatch( resetUserProfile() );
		this.props.dispatch( resetInfinite() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );
	}

	componentDidUpdate() {
		if(
			this.props.userprofileview.isFetching === false &&
			this.props.userprofileview.firstLoad
		) {
			// If can get user's name as id, we need the real userID in the URL
			if(
				this.props.userprofileview.user.id &&
				parseInt( this.props.userprofileview.user.id ) !== parseInt( this.props.routeParams.userid )
			) {

				this.redirect = true;

				this.props.dispatch( replace( {
						pathname: pathToUserProfile( this.props.userprofileview.user.id ),
						query: this.props.location.query.page || 1
					} )
				);
			}

			this.repositionScroll();

		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
 		this.dispatchFetchUserProfile( this.props );
		this.repositionScroll();
	}

	componentWillUnmount() {
		this.props.dispatch( resetUserProfile() );
		this.props.dispatch( resetForum() );
		this.props.dispatch( resetThread() );
		this.props.dispatch( resetInfinite() );
	}

	componentWillReceiveProps(nextProps) {
		if( this.props.routeParams.userid !== nextProps.routeParams.userid ) {
			if( this.redirect === false ) {
				this.props.dispatch( resetUserProfile() );
				this.props.dispatch( resetInfinite() );
				this.props.dispatch( resetForum() );
				this.props.dispatch( resetThread() );

				this.dispatchFetchUserProfile( nextProps );
				this.repositionScroll();
			} else {
				this.redirect = false;
			}
		}

		if( nextProps.userprofileview.loaded && nextProps.userprofileview.loaded !== this.props.userprofileview.loaded ) {
			// trigger ad updates
			this.props.dispatch( onPageView() );
			// Record the Google Analytics pageview
			this.props.dispatch( trackPageView() );
		}
	}

	repositionScroll = () => {
		if( this.header ) {
			let headerDim = this.header.getBoundingClientRect();

			if( headerDim.height && headerDim.height !== this.state.headerHeight ) {
				this.setState( { headerHeight: headerDim.height } );
			}
		}
	};

	loadPage = ( page, forceRefresh ) => {
		this.props.dispatch( fetchUserProfile( {
			id: this.props.routeParams.userid,
			page: page,
			forceRefresh: forceRefresh
		} ) );
	};

	userProfileHeader() {
		let { user, loaded } = this.props.userprofileview;

		let stats = !loaded || !this.props.userprofileview.user.id ? null :
			<ul className="stats">
				<li><span>Joined Forum</span> <Date timestamp={ user.joinDate } /></li>
				<li><span>Total Posts</span> <span>{ user.postsCount }</span></li>
				<li><span>Topics Started</span> <span>{ user.topicsCount }</span></li>
			</ul>,
			location = user.location ? <div className="userLocation">Location: { user.location }</div> : null;

		return <header className="thread" ref={ (h) => this.header = h }>
				<div className="left">
					<UserIcon user={ user } layout="userprofile" noAction={ true } />
				</div>
				<div className="right">
					<div className={ `bannedUser${ user.is_banned ? '' : ' hidden'}` }><span>This user is banned</span></div>
					<div className="userProfileName">{ user.userName ? user.userName : '...' }</div>
					{ location }
					{ stats }
				</div>
			</header>;
	}

	profileResults() {
		let { user } = this.props.userprofileview;
		if( user.lastActivityList && user.lastActivityList.length > 0 ) {
			return <PostList threadview={ this.props.userprofileview } isUserProfile={ true } />;
		} else {
			return null;
		}
	}

	render() {
		let { isFetching, loaded } = this.props.userprofileview;

		if( !loaded ) {
			return ( <div className="userProfile">{ this.userProfileHeader() }<LoaderCss style={ { marginTop: this.state.headerHeight + 'px' } } /></div> );
		}

		let bottomAdUnit = <AdComponent key={ `thread_BottomAd` } adType="2" adName="Bottom_Content_Rectangle"  isFetching={ isFetching } />;

		return (
			<div className="userProfile">
				{ this.userProfileHeader() }
				<InfiniteScroll
					scrollRef={ i => this.infiniteScroll = i }
					isFetching={ isFetching }
					loadPage={ this.loadPage }
					location={ this.props.location }
					extraHeaderHeight={ this.state.headerHeight }
				>
					{ this.profileResults() }
				</InfiniteScroll>
				{ bottomAdUnit }
			</div>
		);
	}
}

export default connect( userprofileResultSelector )(UserProfileViewComponent);


// WEBPACK FOOTER //
// ./src/components/UserprofileViewComponent.js